

















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Attribute } from '@/interfaces/Attribute';
import { Category } from '@/interfaces/Category';
import AttributeCategorizedListTabItemDetailsDialog from '@/components/Attributes/AttributeCategorizedListTabItemDetailsDialog.vue';
import AttributeCategorizedListTabItemCard from '@/components/Attributes/AttributeCategorizedListTabItemCard.vue';
import { Environment } from '@/interfaces/Environment';

@Component({
  components: { AttributeCategorizedListTabItemCard, AttributeCategorizedListTabItemDetailsDialog }
})
export default class AttributesViewTabItem extends Vue {
  @Prop()
  attributes!: Attribute[];

  @Prop()
  category!: Category;

  @Prop()
  categories!: Category[];

  @Prop()
  environments!: Environment[];

  @Prop()
  selectedEnvironment?: number;

  valueForSelectedEnvironment(blueprint: Attribute): string {
    if (blueprint.dependingAttributes.length !== 1) return '';

    const attribute = blueprint.dependingAttributes[0];

    if (!this.selectedEnvironment) return attribute.value_txt || '';

    const attributeEnvironment = attribute.environments.find(
      (aE) => aE.environment_id === this.selectedEnvironment
    );
    if (attributeEnvironment?.value_txt) return attributeEnvironment.value_txt;
    return `<span style="color: rgba(0, 0, 0, 0.54);">${attribute.value_txt || ''}</span>`;
  }

  get attributesList(): Attribute[] {
    return this.attributes?.map((attribute) => {
      if (attribute.blueprint) return { ...attribute.blueprint, dependingAttributes: [attribute] };
      return attribute;
    });
  }
}
